/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  console.log('custom.js loaded');

  document.addEventListener('click', function(e) {
    var target = e.target.closest('[data-swatch-variant]');
    if (!target) return;

    var variantIds = target.getAttribute('data-swatch-variant');
    if (!variantIds) return;

    var variantId = variantIds.split(',')[0];
    if (!variantId) return;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.hash = 'ProductInfo';   //
    window.location.href = url.toString();
  }, true);

})();